import locale from "localization";

export const priceMovementColumns = [
  { key: "priceMovementId", text: locale.priceMovementId, width: "25%" },
  { key: "product", text: locale.product, width: "8%" },
  { key: "priceMovement", text: locale.priceMovement, width: "8%" },
  { key: "createdDate", text: locale.createdDate, width: "8%" },
  { key: "effectiveDate", text: locale.effectiveDate, width: "8%" },
];
